import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import React from 'react';
import { styled } from "@mui/material/styles";


export default function ToggleSelector({value, onChange, options, additionalStyles, isPillView}) {
    const NewToggleButton = styled(ToggleButton)({
        color: '#0A4FB4',
        borderRadius: '1.5rem',
        border: 'none',
        height: '2rem',
        '&.Mui-selected, &.Mui-selected:hover': {
            border: '1px solid #0A4FB4',
            backgroundColor: '#0A4FB4',
            color: '#fff' ,  
        },
        '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
            borderLeft: 'none'
        },
        '&.MuiToggleButtonGroup-grouped:not(:last-of-type),&.MuiToggleButtonGroup-grouped:not(:first-of-type)':{
            borderRadius: '1.5rem',
        },
        '&.Mui-disabled, &.Mui-disabled:hover': {
            color: '#00000042',
            backgroundColor: 'transparent',
            border: 'none',
            pointerEvents: 'none',
            cursor: 'not-allowed'
        },
        display: "flex",
        flexGrow: 1,
      });

    const PillToggleButton = styled(ToggleButton)({
        color: '#0a4fb4',
        backgroundColor: '#fff',
        "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: '#0a4fb4',
            color: '#fff'
        }
    })
      
    //additional style for options to be dynamically even based on the number of options
    const toggleButtonGroupSx = {
        display: 'flex',
        justifyContent: "space-evenly",
        width: '100%', // Use the full width of the container
    };

    if(isPillView) {
        return <>
            {
                options?.map(option => 
                    <PillToggleButton 
                        value={option.value} 
                        onClick= {onChange}                        
                        selected={ option.value === value }
                        sx={{
                            mx:1,
                            width: '100%',
                            height: '2.5rem',
                            borderRadius: '1.5rem',
                            fontWeight: 'bold',
                        }}
                        disabled={option.disabled || false} // If disabled is not provided, default to false
                    > 
                        {option.label} 
                    </PillToggleButton>
                )
            }
        </>

    }
    return (
        <Box sx={{
            backgroundColor: '#fff',
            borderRadius: '1.5rem',
            padding: '.15rem',
            border: '1px solid #d8d8d8'
        }}>
            <ToggleButtonGroup
                size="small"
                value={value}
                exclusive
                onChange={onChange}
                aria-label="toggle-selector"
                sx={toggleButtonGroupSx}
            >
                {
                    options?.map(option => 
                        <NewToggleButton 
                            value={option.value} 
                            sx={{ ...additionalStyles, px: 2}}
                            disabled={option.disabled || false} // If disabled is not provided, default to false
                        > 
                            {option.label} 
                        </NewToggleButton>
                    )
                }
            </ToggleButtonGroup>
        </Box>
    )
}